import React, { Component } from "react";
import * as MaterialIcons from '@material-ui/icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import "./VerticalTimeline.css";
import "./About.css";

export default class About extends Component {

  render() {
    return (
      <div className="about">
        <h1>My Cloud Line</h1>
        <p>A customizable event timeline repository</p>

        <br />
        <br />

        <h2>Publish your timeline in 3 steps</h2>

        <VerticalTimeline>
          <VerticalTimelineElement
                className="vertical-timeline-element--left"
                iconStyle={{ background: "#2196f3", color: '#fff' }}
                icon={<MaterialIcons.Face />}
                key={0}
              >
                <h3 className="vertical-timeline-element-title">Live it</h3>
          </VerticalTimelineElement>
          <VerticalTimelineElement
                className="vertical-timeline-element--left"
                iconStyle={{ background: "#3f51b5", color: '#fff' }}
                icon={<MaterialIcons.Build />}
                key={1}
              >
                <h3 className="vertical-timeline-element-title">Build it</h3>
          </VerticalTimelineElement>
          <VerticalTimelineElement
                className="vertical-timeline-element--left"
                iconStyle={{ background: "#673ab7", color: '#fff' }}
                icon={<MaterialIcons.Share />}
                key={2}
              >
                <h3 className="vertical-timeline-element-title">Share it</h3>
          </VerticalTimelineElement>
        </VerticalTimeline>

        <h2>Common use cases</h2>

        <VerticalTimeline>
          <VerticalTimelineElement
                className="vertical-timeline-element--right"
                iconStyle={{ background: "#f44336", color: '#fff' }}
                icon={<MaterialIcons.Work />}
                key={0}
              >
                <h3 className="vertical-timeline-element-title">Share your career path</h3>
          </VerticalTimelineElement>
          <VerticalTimelineElement
                className="vertical-timeline-element--right"
                iconStyle={{ background: "#2196f3", color: '#fff' }}
                icon={<MaterialIcons.Accessibility />}
                key={1}
              >
                <h3 className="vertical-timeline-element-title">Visualize your personal achievements</h3>
          </VerticalTimelineElement>
          <VerticalTimelineElement
                className="vertical-timeline-element--right"
                iconStyle={{ background: "#4caf50", color: '#fff' }}
                icon={<MaterialIcons.Terrain />}
                key={2}
              >
                <h3 className="vertical-timeline-element-title">Plan your travel goals</h3>
          </VerticalTimelineElement>
        </VerticalTimeline>

        <br />
        <br />

        <h2>Acknowledgements</h2>
        <h3>Inspiration for this application came from the following sources</h3>

        <VerticalTimeline>
          <VerticalTimelineElement
                className="vertical-timeline-element"
                iconStyle={{ background: "#607d8b", color: '#fff' }}
                icon={<MaterialIcons.Cloud />}
                key={0}
              >
                <h3 className="vertical-timeline-element-title">Serverless Stack</h3>
                <p>
                  Amazon Web Services - Serverless Tutorial<br />
                  <a href="https://serverless-stack.com/" target="_blank" rel="noopener noreferrer">Serverless Stack</a>
                </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
                className="vertical-timeline-element"
                iconStyle={{ background: "#ff9800", color: '#fff' }}
                icon={<MaterialIcons.Timeline />}
                key={1}
              >
                <h3 className="vertical-timeline-element-title">React Vertical Timeline</h3>
                <p>
                  React component for the visualization of the timeline<br />
                  <a href="https://github.com/stephane-monnot/react-vertical-timeline" target="_blank" rel="noopener noreferrer">React Vertical Timeline</a>
                </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/About.js